import * as S from '../sgvizler';
/**
 * Handles all logging, either to console or designated HTML
 * container.
 *
 * @class sgvizler.Logger
 * @memberof sgvizler
 */
export class Logger {
    static done(callback) {
        this._doneCallEvent = callback;
        return this;
    }
    static fireDoneEvent(container) {
        container.loadingIcon.hide();
        if (this._doneCallEvent) {
            this._doneCallEvent(container.id);
        }
    }
    static fail(callback) {
        this._failCallEvent = callback;
        return this;
    }
    static fireFailEvent(container) {
        container.loadingIcon.hide();
        if (this._failCallEvent) {
            this._failCallEvent(container.id);
        }
    }
    /**
     * Logs a message.
     * @method log
     * @protected
     * @param {string} message The message to log.
     */
    static log(container, message) {
        if (container.loglevel === 2) {
            console.log(this.elapsedTime() + 's: ' + message);
        }
    }
    static logSimple(message) {
        console.log(this.elapsedTime() + 's: ' + message);
    }
    /**
     * Todo
     * @param {Container} container
     * @param {MESSAGES} messageName
     * @param {Array<string>} args
     */
    static displayFeedback(container, messageName, args) {
        let message = S.Messages.get(messageName, args);
        if (container.loglevel === 2) {
            if (message) {
                let obj = document.getElementById(container.id);
                if (obj) {
                    obj.innerHTML = "<p style='color:red'>" + message + '</p>';
                }
            }
        }
        Logger.fireFailEvent(container);
    }
    /**
     * @method timeElapsed
     * @private
     * @return {number} The number of seconds elapsed since
     * this sgvizler got loaded.
     */
    static elapsedTime() {
        return (Date.now() - this._startTime) / 1000;
    }
}
/**
 * The timestamp for the load start of the current running
 * version of sgvizler. Used to calculate time elapse of
 * future events.
 */
Logger._startTime = Date.now();
//# sourceMappingURL=data:application/json;base64,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